import moment from 'moment';
import React, { useState } from 'react';
import { formattedAmount } from '../../../../utils/helpers/Functions.helper';
import { toast } from 'react-toastify';
import { deliveryReassignApi } from '../../../../App/api/a&uApi';
import OrderApi from '../../../../App/api/order.apis';

const AssignOrderModal = ({allDeliveryMan,OrderDataFun,activeType,selectedSubTab, isAssignModal, setIsAssignModal, itemData }) => {
  const [showManualAssign, setShowManualAssign] = useState(false);
  const [showAutoAssign, setShowAutoAssign] = useState(false);
  const [isDeliveryManID, setDeliveryManID] = useState("");
  const [autoAssignRange, setAutoAssignRange] = useState("5");

  const orderDetailId =
    activeType === "ecommerce"
      ? itemData?.orderDetails?.[0]?._id
      : itemData?._id;

  const handleManualAssign = async (deliveryManId) => {
    if (!deliveryManId) {
      toast.error("Please select a deliveryman");
      return;
    }

    const value = {
      vendor_action: "ASSIGN_TO_DELIVERYMAN",
      orderId: orderDetailId,
      delivery_person_id: deliveryManId || null,
    };
    const payload = {
      deliveryPersonnelId: deliveryManId || null
    };

    try {
      const res =
        selectedSubTab === "Assigned"
          ? await deliveryReassignApi.reAssignDeliveryMan(orderDetailId, payload)
          : await OrderApi.updateOrders(value);
      console.log("delivery assign:",res);
      
      toast.success(selectedSubTab==="Assigned"?"Re-Assign to Deliveryman Successfully":"Assign to Deliveryman Successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to assign deliveryman");
    } finally {
      setIsAssignModal(false);
      setShowManualAssign(false);
      setShowAutoAssign(false);
      OrderDataFun();
      setDeliveryManID("");
      setAutoAssignRange("5");
    }
  };

  const handleAutoAssign = async () => {
    const value = {
      orderId: orderDetailId,
      vendor_action: "AUTO_ASSIGN_TO_DELIVERYMAN",
      range: autoAssignRange,
    };

    try {
      const res = await OrderApi.updateOrders(value);
      console.log("auto assign:", res);
      toast.success(res?.data?.message || "Order auto-assigned successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to auto-assign order");
    } finally {
      setIsAssignModal(false);
      setShowManualAssign(false);
      setShowAutoAssign(false);
      OrderDataFun();
      setDeliveryManID("");
      setAutoAssignRange("5");
    }
  };

  const handleBack = () => {
    setShowManualAssign(false);
    setShowAutoAssign(false);
  };

  const isAutoAssignDisabled = !autoAssignRange || Number(autoAssignRange) <= 0;
  const hasDeliveryMen = (allDeliveryMan?.length || 0) > 0;

  const renderAssignContent = () => {
    if (showManualAssign) {
      return (
        <div>
          <h2 className="text-lg font-semibold">Select Delivery Personnel</h2>
          <div className="space-y-2 mt-2">
             {hasDeliveryMen ? (
                <div className="flex flex-col space-y-3">
                  {allDeliveryMan.map((person) => (
                    <label
                      key={person?.userId || person?._id}
                      className="flex items-center p-3 border rounded-lg shadow-sm hover:bg-gray-50 cursor-pointer transition"
                    >
                      <input
                        type="radio"
                        name="deliveryPerson"
                        value={person?._id}
                        checked={isDeliveryManID === person?._id}
                        className="form-radio h-4 w-4 text-blue-600"
                        onChange={() => setDeliveryManID(person?._id)}
                      />
                      <span className="ml-3 font-medium text-gray-700">
                        {person?.firstName} {person?.lastName}
                      </span>
                    </label>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 rounded-xl bg-gray-50 text-center">
                  <span className="text-gray-500 text-lg font-semibold">
                    No Delivery Personnel Available
                  </span>
                </div>
              )}
          </div>
        </div>
      );
    }

   if (showAutoAssign) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Auto Assign Deliveryman</h2>
        <p className="text-sm text-gray-500 mt-1">
          Set the search range used to find the nearest deliveryman.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Range
        </label>

        <select
          value={autoAssignRange}
          onChange={(e) => setAutoAssignRange(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 bg-white outline-none focus:border-blue-500"
        >
          <option value="">Select range</option>
          <option value="5">0 - 5 km</option>
          <option value="10">5 - 10 km</option>
          <option value="10+">10+ km</option>
        </select>
      </div>
    </div>
  );
}

    return (
      <div className="space-y-1">
        <p><strong>Order ID:</strong> {itemData?.order_id}</p>
        <p><strong>Order Type:</strong> {itemData?.order_type}</p>
        <p><strong>No of Orders:</strong> {itemData?.orderDetails?.length}</p>
        <p><strong>Order Date:</strong> {moment(itemData.order_date).format('MMM Do, YYYY')}</p>
        <p>
          <strong>Delivery Address:</strong> {itemData.delivery_address.street},
          {itemData.delivery_address.city.name}, {itemData.delivery_address.country.name}
        </p>
        <p><strong>Order Cost:</strong> {formattedAmount(itemData?.net_total?.$numberDecimal)}</p>
        <p><strong>Payment Status:</strong> {itemData?.payment_status}</p>

        <p className="pt-4 font-bold">Vendor Contacts</p>
        <hr className="p-0 m-0" />
        <p><strong>Shop Name:</strong> {itemData?.orderDetails[0]?.vendor?.first_name || itemData?.vendor_details?.first_name}</p>
        <p><strong>Contact No:</strong> {itemData?.orderDetails[0]?.vendor?.phone_number || itemData?.vendor_details?.phone_number}</p>
        <p><strong>Contact Email:</strong> {itemData?.orderDetails[0]?.vendor?.email || itemData?.vendor_details?.email}</p>

        <p className="pt-4 font-bold">Customer Contacts</p>
        <hr />
        <p><strong>Ordered By:</strong> {itemData.delivery_address.name}</p>
        <p><strong>Contact No:</strong> {itemData.delivery_address.phone_number}</p>
      </div>
    );
  };

  const renderFooterButtons = () => {
    if (showManualAssign) {
      return (
        <>
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            onClick={handleBack}
          >
            Back
          </button>
          {hasDeliveryMen && (
            <button
              className="bg-indigo-800 text-white px-4 py-2 rounded hover:bg-indigo-900 disabled:cursor-not-allowed disabled:bg-indigo-400"
              onClick={() => handleManualAssign(isDeliveryManID)}
              disabled={!isDeliveryManID}
            >
              Assign Selected
            </button>
          )}
        </>
      );
    }

    if (showAutoAssign) {
      return (
        <>
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            onClick={handleBack}
          >
            Back
          </button>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-blue-300"
            onClick={handleAutoAssign}
            disabled={isAutoAssignDisabled}
          >
            Confirm Auto Assign
          </button>
        </>
      );
    }

    return (
      <>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            onClick={() => {
              setShowManualAssign(false);
              setShowAutoAssign(true);
            }}
          >
            Auto Assign
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            onClick={() => {
              setShowAutoAssign(false);
              setShowManualAssign(true);
            }}
          >
            Manual Assign
          </button>
      </>
    );
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#111827d9] bg-opacity-80 w-full">
    <div className="bg-white rounded-lg shadow-lg w-full max-w-md sm:max-w-xl md:max-w-2xl h-[60%] flex flex-col">
      
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b font-bold text-xl sticky top-0 bg-white z-10">
        <h1>Assign Order</h1>
        <div
          onClick={() => setIsAssignModal(false)}
          className="cursor-pointer hover:text-red-600"
        >
          X
        </div>
      </div>
  
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
        {renderAssignContent()}
      </div>
  
      {/* Footer Buttons */}
      <div className="p-4 border-t flex justify-center gap-2 sticky bottom-0 bg-white z-10">
        {renderFooterButtons()}
      </div>
  
    </div>
  </div>
  
  );
};

export default AssignOrderModal;
